import {
  AGENCY,
  MASTER_CAMPAIGN,
  INFLUENCER_CHANNEL,
  LANDING_PAGE,
  IOS_LANDING_PAGE,
  ANDROID_LANDING_PAGE,
  REWARD_PACKAGE,
  ADDITIONAL_REWARD_PACKAGE,
  ADDITIONAL_REWARD_CONDITION,
} from 'scenes/Influencers/InfluencersCampaigns/components/InfluencerCampaignForm/constants';

import { PLATFORM_ID, ADDITIONAL_PARAMS } from './constants';

export const getGGCampaignLinkDependencies = (name) => [
  MASTER_CAMPAIGN,
  AGENCY,
  INFLUENCER_CHANNEL,
  LANDING_PAGE,
  IOS_LANDING_PAGE,
  ANDROID_LANDING_PAGE,
  REWARD_PACKAGE,
  ADDITIONAL_REWARD_PACKAGE,
  ADDITIONAL_REWARD_CONDITION,
  `${name}.${PLATFORM_ID}`,
  `${name}.${ADDITIONAL_PARAMS}`,
];
